<loading-animation size="large" *ngIf="!isReady"></loading-animation>

<div class="bulk-operation-wrapper" [formGroup]="deviceFirmwareUpdateBulkFormGroup" *ngIf="isReady">
    <popup-header text="Update Firmware Version" (clickAction)="cancel()"></popup-header>

    <div mat-dialog-content fxLayout="column" class="bulk-operation-description">
        <mat-form-field fxFlex.sm="100" fxFlex.xs="100" fxFlex.gt-sm="50">
            <mat-label>Firmware Version</mat-label>
            <mat-select [formControl]="versionFormControl" (selectionChange)="updateVersion($event)">
                <mat-option *ngFor="let item of firmwareVersions" [value]="item.version">
                    {{ item.version }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>

    <popup-button-container>
        <cas-button (clickAction)="cancel()" btnText="Cancel"></cas-button>
        <cas-button color="accent" (clickAction)="confirm()" btnText="Confirm"></cas-button>
    </popup-button-container>
</div>